export default __webpack_public_path__ + "static/media/reportes.26851bcf.svg";